import { render } from "./SectionTitleCenturyNoSize.vue?vue&type=template&id=66834984"
import script from "./SectionTitleCenturyNoSize.vue?vue&type=script&lang=js"
export * from "./SectionTitleCenturyNoSize.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__